import type {
  ChronologicalItinerary,
  FerryIngredientResponseWithStaticInfo,
  FlightIngredientResponseWithStaticInfo,
  HotelIngredientResponseWithStaticInfo,
  IngredientType,
  ItineraryWithPrice,
  OwnStayIngredientResponseWithStaticInfo,
  OwnTransportIngredientResponseWithStaticInfo,
} from '@libs/trip-planner-interfaces';

export interface DatePeriodForStopParams {
  format: 'long' | 'short';
  stop: ChronologicalItinerary;
  isLastStop?: boolean;
  isSmallDevice?: boolean;
}
export interface DateWithItinerary {
  date: Date;
  itinerary?: ItineraryWithPrice;
}

export type MainIngredientResponseWithStaticInfo =
  | OwnStayIngredientResponseWithStaticInfo
  | OwnTransportIngredientResponseWithStaticInfo
  | HotelIngredientResponseWithStaticInfo
  | FlightIngredientResponseWithStaticInfo
  | FerryIngredientResponseWithStaticInfo;

export type MissingIngredientResponseStaticInfoError =
  | MissingOwnStayStaticInfoError
  | MissingHotelStaticInfoError
  | MissingActivitiesStaticInfoError
  | MissingTransportStaticInfoError
  | MissingOwnTransportStaticInfoError;

export class MissingOwnStayStaticInfoError extends Error {
  public type = 'MissingOwnStayStaticInfoError';
}

export class MissingHotelStaticInfoError extends Error {
  public type = 'MissingHotelStaticInfoError';

  constructor(
    public date: Date,
    public code?: string,
    public availability?: 'available' | 'alternative'
  ) {
    super();
  }
}

interface ActivityMissingStaticInfoErrorData {
  availability: 'available' | 'alternative';
  date: Date;
  code: string;
}

export class MissingActivitiesStaticInfoError extends Error {
  public type = 'MissingActivitiesStaticInfoError';

  constructor(
    public activitiesWithMissingStaticInfo: ActivityMissingStaticInfoErrorData[]
  ) {
    super();
  }
}

export class MissingTransportPortStaticInfoError extends Error {
  public type = 'MissingTransportPortStaticInfoError';

  constructor(public misingPorts: string[]) {
    super();
  }
}
export class MissingTransportCarrierStaticInfoError extends Error {
  public type = 'MissingTransportCarrierStaticInfoError';

  constructor(public missingCarriers: string[]) {
    super();
  }
}

export class MissingTransportStaticInfoError extends Error {
  public type = 'MissingTransportStaticInfoError';

  constructor(
    public transportType: IngredientType.Ferry | IngredientType.Flight,
    public date: Date,
    public availability: 'available' | 'alternative',
    public transportIds: string[],
    public missingPorts: string[],
    public missingCarriers: string[]
  ) {
    super();
  }
}

export class MissingOwnTransportStaticInfoError extends Error {
  public type = 'MissingOwnTransportStaticInfoError';
}

export class MissingItineraryAvailabilityError extends Error {
  public type = 'MissingItineraryAvailabilityError';
}

export class MissingItineraryStaticInfoError extends Error {
  public type = 'MissingItineraryStaticInfoError';

  constructor(
    public ingredientErrors: MissingIngredientResponseStaticInfoError[]
  ) {
    super();
  }
}
